<script lang="ts">
  import Container from '$lib/site/Container.svelte'
  import Signup from '$lib/site/Signup.svelte'
  import { variables } from '$lib/variables.js'

  const { data } = $props()
</script>

<svelte:head>
  <title>The {variables.appName} Blog</title>
  <meta
    name="description"
    content="Join us on our journey as we build a beautiful tool to create & share maps."
  />
</svelte:head>

<Container nav />
<div class="signup-bg">
  <Container padding>
    <div class="signup">
      <h1>The Turbomaps Blog</h1>
      <Signup />
    </div>
  </Container>
</div>
<Container footer padding>
  {#each data.posts as post (post.filename)}
    <article class="post">
      <time>{post.date}</time>
      <a href={`/blog/${post.filename}`} class="title"><h2>{post.title}</h2></a>
      <p>{@html post.excerpt}</p>
      <a href={`/blog/${post.filename}`} class="continue">Continue reading &rarr;</a>
    </article>
  {/each}
</Container>

<style>
  .signup-bg {
    background: var(--surface-bg-subtle);
    border-bottom: 1px solid var(--surface-border-subtle);
  }
  .signup {
    text-align: center;
  }
  h1 {
    font-size: 2rem;
    letter-spacing: -0.5px;
  }
  @media (min-width: 500px) {
    h1 {
      font-size: 2.5rem;
    }
  }
  a {
    color: var(--surface-text-interactive);
  }
  .post {
    padding: 1rem 0 1.5rem;
    margin: 0 auto 1rem;
    border-radius: 0.75rem;
    max-width: 650px;
  }
  @media (min-width: 500px) {
    .post {
      border-radius: 1rem;
      padding: 2.5rem 3rem 2rem;
    }
  }
  .post time {
    font-size: 0.8rem;
    margin: 0.25em 0 2em;
    color: var(--surface-text-faint);
    font-weight: bold;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }
  .post a.title {
    color: inherit;
    text-decoration: none;
  }
  .post h2 {
    font-size: 1.25rem;
    letter-spacing: -0.5px;
    line-height: 1.3;
    margin: 0.25em 0;
    font-family: var(--font-serif);
  }
  .post p {
    font-size: 1rem;
    line-height: 1.5;
  }
  @media (min-width: 500px) {
    .post h2 {
      font-size: 1.75rem;
    }
    .post p {
      font-size: 1.125rem;
    }
  }
  .post .continue {
    font-size: 0.8rem;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    font-weight: bold;
    margin: 1rem 0;
    display: block;
  }
</style>
